export class ValidationResponse {
    isValid: boolean;
}